import * as React from 'react';
import {Paper, Typography} from '@mui/material';

// One headline number, with how it compares. No colour judges the change: more is not always better.
export function KpiTile({label, value, caption}: { label: string, value: string, caption: string }) {
    return (
        <Paper variant="outlined" sx={{p: {xs: 2, sm: 2.5}, borderRadius: 2, minWidth: 0, display: 'flex', flexDirection: 'column'}}>
            <Typography variant="body2" color="text.secondary" sx={{fontWeight: 550}}>{label}</Typography>
            <Typography component="p" sx={{my: 1, fontSize: {xs: 32, sm: 38}, fontWeight: 650, lineHeight: 1.2, letterSpacing: '-0.04em', fontVariantNumeric: 'tabular-nums'}}>{value}</Typography>
            <Typography variant="caption" color="text.secondary" sx={{mt: 'auto', lineHeight: 1.6}}>{caption}</Typography>
        </Paper>
    );
}
